import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const addCoach = async (coach) => {
    return axios.post(`${BACKEND_URL}/coaches`, coach);
};

export const getAllCoaches = async () => {
    return axios.get(`${BACKEND_URL}/coaches`);
};

export const getCoachesOfAthlete = async (email) => {
    return axios.get(`${BACKEND_URL}/athletes/${email}/coaches`);
};

export const getParentsOfCoach = async (email) => {
    return axios.get(`${BACKEND_URL}/coaches/${email}/parents`);
};

export const updateAthletesOfCoach = async (email, athletes) => {
    return axios.put(`${BACKEND_URL}/coaches/${email}`, athletes);
};